export enum AttachmentSphere {
  INSCRICAO = "INSCRICAO",
  USUARIO = "USUARIO"
}
